import { inToolboxItems } from '../../canvas/tooling/ToolboxController';
import { inTool } from '../../canvas/tooling/ToolManager';
import { Package, PackageHost } from '../../Container';
import { layoutLibraryToolboxItem } from './LayoutLibraryToolboxItem';
import { layoutTool } from './LayoutTool';

export class LayoutPackage implements Package {

    public install = (host: PackageHost) => host
        .plug(inTool(layoutTool))
        .plug(inToolboxItems(layoutLibraryToolboxItem))
        ;
}
